const { version } = require("../package.json");

window.addEventListener("DOMContentLoaded", () => {
  let dev = "";
  if (process.env.NODE_ENV !== "production") {
    dev = "-dev";
  }
  document.querySelector<HTMLSpanElement>("#version").innerHTML = version + dev;
});